var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.834 1.313h-1.896V.438a.437.437 0 10-.876 0v.875H7.438V.438a.437.437 0 10-.875 0v.875H3.938V.438a.437.437 0 10-.876 0v.875H1.167C.522 1.313 0 1.833 0 2.478v10.354C0 13.478.522 14 1.167 14h11.667c.644 0 1.166-.522 1.166-1.167V2.48c0-.645-.522-1.167-1.166-1.167zm.291 11.52c0 .161-.13.292-.291.292H1.167a.292.292 0 01-.292-.292V2.48c0-.16.13-.292.292-.292h1.895v.876a.437.437 0 10.876 0v-.876h2.624v.876a.437.437 0 10.875 0v-.876h2.625v.876a.437.437 0 10.876 0v-.876h1.896c.16 0 .291.131.291.292v10.354z",
    fill: "#C4C4D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.812 5.25h-1.75v1.313h1.75V5.25zM4.812 7.438h-1.75V8.75h1.75V7.437zM4.812 9.625h-1.75v1.313h1.75V9.624zM7.875 9.625h-1.75v1.313h1.75V9.624zM7.875 7.438h-1.75V8.75h1.75V7.437zM7.875 5.25h-1.75v1.313h1.75V5.25zM10.937 9.625h-1.75v1.313h1.75V9.624zM10.937 7.438h-1.75V8.75h1.75V7.437zM10.937 5.25h-1.75v1.313h1.75V5.25z",
    fill: "#C4C4D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9d564d2b5aad557a11499cfc211539a6.svg";
export { ForwardRef as ReactComponent };